import { render, staticRenderFns } from "./SubComment.vue?vue&type=template&id=403c5117&"
import script from "./SubComment.vue?vue&type=script&lang=js&"
export * from "./SubComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports